import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.300',
    endColor: 'alpha.400',
    minW: 'full',
    h: '20',
    borderRadius: 'md',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    fontFamily: 'accent',
    fontSize: 'xs',
    color: '#FFFFFFA3 !important',
    sxWrapper: {
      mb: '0',
    },
    borderRadius: 'base',
    mb: '0',
    border: 'none !important',
    bg: '#0000003D !important',
    _hover: {
      '&&': {
        _placeholder: {
          color: 'whiteAlpha.700',
        },
        border: 'none',
        boxShadow: 'none',
      },
      color: 'whiteAlpha.700',
    },
    _focus: {
      '&&': {
        _placeholder: {
          color: 'whiteAlpha.700',
        },
        border: 'none',
        boxShadow: 'none',
      },
      color: 'whiteAlpha.700',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'whiteAlpha.700',
      fontWeight: 'bold',
      fontSize: 'xs',
    },
    sx: {
      '&&&&': {
        bg: 'blackAlpha.400',
        color: 'whiteAlpha.700',
        boxShadow:
          '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
        _placeholder: {
          color: 'whiteAlpha.700',
        },
      },
    },
  },
  inputRightIcon: {
    sx: {
      color: 'gamma.400',
      boxSize: '4',
    },
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: {
    alignItems: 'center',
    gap: 2,
    flex: 1,
    textAlign: 'left',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
  },
  accordionButtonIconSvg: {
    sx: {
      fontSize: 'md',
      color: 'alpha.200',
      filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.25))',
    },
  },
  accordionButtonText: {
    fontSize: 'lg',
    fontWeight: 'normal',
    fontFamily: 'Staatliches',
    textTransform: 'uppercase',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
  },
  accordionButtonInnerIcon: {
    sx: {
      pos: 'absolute',
      right: '0',
      boxSize: '6',
      color: 'gamma.400',
    },
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
